import { PackagePlus } from "lucide-react";
import { money } from "@/lib/api";
import { CART } from "@/constants/testIds";

export const BundleNudge = ({ n, onAdd }) => (
  <div data-testid={CART.nudge(n.bundle)} className="flex items-center gap-3 rounded-2xl bg-[#FDF2EC] border border-[#F5D9CB] p-3 animate-in fade-in slide-in-from-top-1 duration-300">
    {n.product.image && <img src={n.product.image} alt="" className="w-12 h-12 rounded-xl object-cover bg-white shrink-0" />}
    <p className="flex-1 text-sm leading-snug">
      Add <strong>{n.product.name}</strong> ({money(n.product.price)}) to save <strong className="text-[#E06D44]">{money(n.saving)}</strong> with {n.name}.
    </p>
    <button
      data-testid={CART.nudgeAdd(n.bundle)}
      onClick={onAdd}
      className="shrink-0 inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-[#1C1917] text-white text-xs font-semibold hover:bg-[#E06D44] transition-colors"
    >
      <PackagePlus size={14} /> Add
    </button>
  </div>
);
